var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ListContactsAnswered, ListContactsWithoutProspecting, ListContactsWithStartedProspection, } from '@/clients/llm';
import { Component, Prop, Vue } from 'vue-property-decorator';
let Newkanbam = class Newkanbam extends Vue {
    constructor() {
        super(...arguments);
        this.channel = 'whatsapp';
        this.infoSetId = '';
        this.columns = [
            {
                id: 'not_contacted',
                title: 'Não Contatado',
                slug: 'not_contacted',
                cards: [],
                totalItems: 0,
                hasMore: true,
                isLoading: false,
                page: 1,
            },
            {
                id: 'contacted',
                title: 'Contatado',
                slug: 'contacted',
                cards: [],
                totalItems: 0,
                hasMore: true,
                isLoading: false,
                page: 1,
            },
            {
                id: 'answered',
                title: 'Respondido',
                slug: 'answered',
                cards: [],
                totalItems: 0,
                hasMore: true,
                isLoading: false,
                page: 1,
            },
        ];
    }
    mounted() {
        this.infoSetId = this.infoSetIdProp || this.$route.params.infoSetId;
        const urlParams = new URLSearchParams(window.location.search);
        this.channel = this.channelProp || urlParams.get('canal') || 'whatsapp';
        // Carrega a primeira página de dados para todas as colunas
        this.columns.forEach(column => {
            this.loadMoreTasks(column.id);
        });
    }
    generateCard(column, contact) {
        return {
            id: `${contact[this.channel]}-${contact.nu_cnpj}`,
            columnId: column,
            title: contact[this.channel],
            cnpj: contact.nu_cnpj,
            company_id: contact.company_id,
        };
    }
    async fetchTasks(columnId, page) {
        let total = 0;
        let contacts = [];
        if (columnId == 'not_contacted') {
            const response = await ListContactsWithoutProspecting(this.channel, this.infoSetId, {}, page, 10);
            total = response.data.total;
            contacts = response.data.contacts;
        }
        else if (columnId == 'contacted') {
            const response = await ListContactsWithStartedProspection(this.infoSetId, this.channel, {}, page, 10);
            total = response.data.total;
            contacts = response.data.contacts;
        }
        else if (columnId == 'answered') {
            const response = await ListContactsAnswered(this.infoSetId, this.channel, {}, page, 10);
            total = response.data.total;
            contacts = response.data.contacts;
        }
        return {
            total: total,
            cards: contacts.map(c => this.generateCard(columnId, c)),
        };
    }
    async loadMoreTasks(columnId) {
        const columnIndex = this.columns.findIndex(c => c.id === columnId);
        const column = this.columns[columnIndex];
        if (column.isLoading || !column.hasMore) {
            return;
        }
        // Define isLoading como true (reativo)
        this.$set(this.columns[columnIndex], 'isLoading', true);
        try {
            const result = await this.fetchTasks(columnId, column.page);
            const updatedTasks = [...column.cards, ...result.cards];
            const hasMore = updatedTasks.length < result.total;
            // Atualiza o estado da coluna de forma reativa
            this.$set(this.columns[columnIndex], 'cards', updatedTasks);
            this.$set(this.columns[columnIndex], 'page', column.page + 1);
            this.$set(this.columns[columnIndex], 'hasMore', hasMore);
            this.$set(this.columns[columnIndex], 'totalItems', result.total);
        }
        catch (error) {
            console.error('Erro ao carregar tarefas:', error);
        }
        finally {
            // Define isLoading como false ao finalizar
            this.$set(this.columns[columnIndex], 'isLoading', false);
        }
    }
    /**
     * Handler de Evento de Scroll: aciona o carregamento quando atinge o final.
     */
    handleScroll(event, column) {
        const target = event.target;
        const { scrollTop, scrollHeight, clientHeight } = target;
        // Checa se o usuário rolou até o final (margem de 50px)
        const isNearEnd = scrollTop + clientHeight >= scrollHeight - 50;
        if (isNearEnd && !column.isLoading && column.hasMore) {
            this.loadMoreTasks(column.id);
        }
    }
};
__decorate([
    Prop({ default: () => null })
], Newkanbam.prototype, "infoSetIdProp", void 0);
__decorate([
    Prop({ default: () => null })
], Newkanbam.prototype, "channelProp", void 0);
Newkanbam = __decorate([
    Component({
        name: 'Newkanbam',
    })
], Newkanbam);
export default Newkanbam;
